
import { VehiclPartsListApi } from 'SRC/modules/vehicleParts/list/api'
import { setSimilarProducts } from '../setSimilarProducts'
import { setSimilarProductsLoading } from '../setSimilarProductsLoading'

export const fetchSimilarProducts = ({ fields }) => async (dispatch, getState) => {
  try {
    dispatch(setSimilarProductsLoading(true))

    const api = new VehiclPartsListApi()
    const { products, error } = await api.getProducts(fields)

    console.log('fetchSimilarProducts products', products)

    if (error) {
      dispatch(setSimilarProducts([]))
      dispatch(setSimilarProductsLoading(false))
    } else {
      if (Array.isArray(products) && products.length) dispatch(setSimilarProducts(products))
      else dispatch(setSimilarProducts([]))

      dispatch(setSimilarProductsLoading(false))
    }
  } catch (e) {
    dispatch(setSimilarProducts([]))
    dispatch(setSimilarProductsLoading(false))
  }
}
